<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in $t('BusinessContact.BusinessInfo')">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div
            v-if="i===0"
            class="mb-5"
            v-html="text"
          />
          <div
            v-if="i===1"
            class="mb-8"
            v-html="text"
          />
          <div
            v-if="i===2"
            class="mt-1"
            v-html="text"
          />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== $t('BusinessContact.BusinessInfo').length"
          :key="`divider-${i}`"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },
  }
</script>
